<template>
    <!--  -->
    <div>
        <!--  -->
        <top-stats v-if="currentUser.type == 'Admin' || currentUser.type == 'Seller' || currentUser.type == 'CEO' || $f.getAccessPermission(currentUser, 'analytics', 'create')" />
        <!--  -->

        <!--  -->
        <div class="relative pt-2">
            <!--  -->
            <div class="px-2 mx-auto w-full">
                <!--  -->
                <div class="flex-grow flex flex-col" v-if="currentUser.type == 'Admin' || currentUser.type == 'Seller' || currentUser.type == 'CEO' || $f.getAccessPermission(currentUser, 'analytics', 'create')">
                    <!--  -->
                    <chart-delivery :dataDelivery="dataDelivery" :count="totalShippings" :from="from_sh" :to="to_sh" filter="true" :titledelivery="'Summary of orders by status'" typedelivery="pie" iddelivery="delivery-chart" :timeserchd="timeserchd" :userTypedelivery="currentUser.type" :currentUser="currentUser" :timeserchsellerdelivery="timeserchsellerdelivery" :timeserchsaffiliate_storesdelivery="timeserchsaffiliate_storesdelivery" :timeserchcourierdelivery="timeserchcourierdelivery" :product="timeserchproductdelivery" :labelstringd="labeldeliveryString" :sellers="sellers" :couriers="couriers" :products="products" :prices="prices" :stores="stores" :price="timeserchpricedelivery" @ChangeTypeDateDelivery="ChangeTypeDateDelivery" @ChangeSellerDelivery="ChangeSellerDelivery" @FindRecordShippings="FindRecordShippings"/>
                    <!--  -->
                </div>
                <!--  -->
            </div>
            <!--  -->
        </div>
        <!--  -->
        
        <!--  -->
        <div class="flex flex-wrap px-2">
            <!--  -->
            <div class="w-full" v-if="currentUser.type == 'Admin' || currentUser.type == 'Seller' || currentUser.type == 'CEO'">
                <chart-revenus :chartData="dataRevenu" :chartData1="dataRevenuOrders" :chartData2="dataRevenuOrdersPending" :sumrevenuorder="sumrevenuorder" :sumrevenusPending="sumrevenusPending" :sumrevenus="sumrevenus" :Labels="labelsrevenu" :currency="currency" :label="labelRevenu" :countOrders="countOrders" filter="true" :from="from_r" :to="to_r" :title="$t('revenus')" action="revenu" type="line" id="revenu-chart" :timeserch="timeserch" :sellers="sellers" :userType="currentUser.type" :timeserchseller="timeserchseller" :labelstring="labelrevenuString" @ChangeTypeDateRevenu="ChangeTypeDateRevenu" @ChangeSeller="ChangeSeller" @FindRecordRevenus="FindRecordRevenus"/>
            </div> 
            <!--  -->

            <!--  -->
            <div v-if="currentUser.type == 'Admin' || currentUser.type == 'CEO' || $f.getAccessPermission(currentUser, 'analytics', 'create')" class="w-full lg:w-1/2">
                <card-bar-chart :chartData="dataAllSeller" filter="true" :count="countSellers" :title="'Total Registrants '" type="doughnut" id="seller-chart" :timeserch="timeserchs" :userType="currentUser.type" :labelstring="labelAllsellerString" @ChangeTypeDateAllSeller="ChangeTypeDateAllSeller" @FindRecordSellers="FindRecordSellers"/>
            </div>
            <!--  -->

            <!--  -->
            <div class="w-full lg:w-1/2" v-if="currentUser.type == 'Admin' || currentUser.type == 'Seller' || currentUser.type == 'CEO' || $f.getAccessPermission(currentUser, 'analytics', 'create')">
                <chart-status-orders :chartData="dataconfirmation" :count="countConfirmations" filter="true" :title="$t('confirmation_status')" type="pie" id="confirmation-chart" :timeserch="timeserchc" :sellers="sellers" :userType="currentUser.type" :timeserchseller="timeserchsellerconfirmation" :labelstring="labelconfirmationString" @ChangeTypeDateConfirmation="ChangeTypeDateConfirmation" @ChangeSellerConfirmation="ChangeSellerConfirmation" @FindRecordconfirmations="FindRecordconfirmations"/>
            </div>
            <!--  -->

            <!--  -->
            <div class="w-full lg:w-1/2" v-if="currentUser.type == 'Admin' || currentUser.type == 'Seller' || currentUser.type == 'CEO' || $f.getAccessPermission(currentUser, 'analytics', 'create')">
                <chart-revenus :chartData="dataRevenusellerProducts" :Labels="labelsrevenusellerProducts" :label="'Produits'" :title="$t('Top Produits par commandes Livrés')" type="horizontalBar" id="topproducts-chart" :userType="currentUser.type" :sellers="sellers" :timeserchseller="timeserchsellerproduct" :timeserch="timeserchtopproducts" action="topproducts" :labelstring="labelrevenuStringtopproduct" @ChangeTypeDateRevenu="ChangeTypeDateRevenu" @ChangeSeller="ChangeSellerOrderProduct"/>
            </div>
            <!--  -->

            <!--  -->
            <div class="w-full lg:w-1/2" v-if="currentUser.type == 'Admin' || currentUser.type == 'Seller' || currentUser.type == 'CEO' || $f.getAccessPermission(currentUser, 'analytics', 'create')">
                <chart-revenus :chartData="dataRevenusellerVilles" :Labels="labelsrevenusellerVilles" :label="'Villes'" :title="$t('Top Villes par commandes Livrés')" type="horizontalBar" id="topvilles-chart" :userType="currentUser.type" :sellers="sellers" :timeserchseller="timeserchsellerville" :timeserch="timeserchtopvilles" action="topvilles" :couriers="couriers" :timeserchcouriertopvilles="timeserchcouriertopvilles" :labelstring="labelrevenuStringtopvilles" @ChangeTypeDateRevenu="ChangeTypeDateRevenu" @ChangeSeller="ChangeSellerOrderVilles"/>
            </div>
            <!--  -->

            <!--  -->
            <div v-if="currentUser.type == 'Admin' || currentUser.type == 'Seller' || currentUser.type == 'CEO' || $f.getAccessPermission(currentUser, 'analytics', 'create')" :class="currentUser.type === 'Seller'?'w-full lg:w-1/2':'w-full'">
                <chart-orders :dataorders="dataorders" :titleorders="$t('total_orders')" :from="from_o" :to="to_o" filter="true" typeorders="line" idorders="orders-chart" :timesercho="timesercho" :sellers="sellers" :userTypeorders="currentUser.type" :timeserchsellerorders="timeserchsellerorders" :labelstringo="labelordersString" :Labels="labels" @ChangeTypeDateOrders="ChangeTypeDateOrders" @ChangeSellerOrders="ChangeSellerOrders" @FindRecordOrders="FindRecordOrders"/>
            </div>
            <!--  -->
        </div> 
        <!--  -->
    </div>
    <!--  -->
</template>

<script>
import CardBarChart from '@/components/Analytics/Cards/CardBarChart.vue';
import HeaderFilters from '@/components/Analytics/Cards/HeaderFilters.vue';
import ChartOrders from '@/components/Analytics/Cards/ChartOrders.vue';
import ChartRevenus from '@/components/Analytics/Cards/ChartRevenu.vue';
import ChartStatusOrders from '@/components/Analytics/Cards/ChartStatusOrders.vue';
import HeaderStats from '@/components/Cards/HeaderStats.vue';
import GroupCard from '@/components/Cards/GroupCard.vue';
import TopStats from '@/components/Cards/TopStats.vue';
import ChartDelivery from '@/components/Analytics/Cards/ChartDelivery.vue';

export default {
    name: 'dashboard-page',
    components: {
        ChartRevenus,
        CardBarChart,
        HeaderFilters,
        ChartOrders,
        ChartStatusOrders,
        HeaderStats,
        TopStats,
        GroupCard,
        ChartDelivery,
    },
    data() {
        return {
            token: null,
            formData: {
                startDate: '',
                endDate: '',
            },
            currentUser: {
                role: {},
            },
            tab: [],
            //Revenu
            dataRevenu: [],
            dataRevenuOrders: [],
            dataRevenuOrdersPending: [],
            sumrevenuorder: 0,
            sumrevenus: 0,
            sumrevenusPending: 0,
            countOrders: 0,
            from_r: null,
            to_r: null,
            dataRevenusellerProducts: [],
            dataRevenusellerVilles: [],
            dataStock: [],
            dataExp: [],
            dataExpFees: [],
            timeserch: 'thisyear',
            timeserchStock: 'today',
            timeserchExp: 'today',
            timeserchseller: '',
            timeserchsellerExp: '',
            timeserchsellerproduct: '',
            timeserchsellerville: '',
            timeserchtopproducts: '',
            timeserchtopvilles: '',
            timeserchtockhistoriesproducts: '...',
            timeserchstockhistoriesSeller: '',
            labelsMonths: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ],
            labels: [
                '00:00',
                '01:00',
                '02:00',
                '03:00',
                '04:00',
                '05:00',
                '06:00',
                '07:00',
                '08:00',
                '09:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
            ],
            labelsrevenu: [],
            labelsrevenusellerProducts: [],
            labelsrevenusellerVilles: [],
            labelsStock: [],
            labelsExp: [],
            labelString: 'Hours',
            labelrevenuString: 'Hours',
            labelStringStock: 'Hours',
            labelStringExp: 'Hours',
            labelrevenuStringtopproduct: 'Products',
            labelrevenuStringtopvilles: 'Villes',
            duree: '',
            tabsellers: [],
            tabordersbystatus: [],
            products: [],

            // Dellivery
            timeserchd: 'All',
            labeldeliveryString: 'Days',
            dataDelivery: [],
            timeserchsellerdelivery: '',
            timeserchsaffiliate_storesdelivery: '',
            stores: [],
            timeserchcourierdelivery: '',
            timeserchcouriertopvilles: null,
            timeserchproductdelivery: null,
            timeserchpricedelivery: null,
            prices: [],
            totalShippings: 0,
            from_sh: null,
            to_sh: null,

            // ConfirmationStatus
            timeserchc: 'today',
            labelconfirmationString: 'Days',
            dataconfirmation: [],
            timeserchsellerconfirmation: '',
            countConfirmations: 0,
            from_c: null,
            to_c: null,

            // All Seller
            timeserchs: 'today',
            labelAllsellerString: 'Days',
            dataAllSeller: [],
            countSellers: 0,
            from_s: null,
            to_s: null,

            // Total Orders
            timesercho: 'today',
            labelordersString: 'Hours',
            dataorders: [],
            timeserchsellerorders: '',
            from_o: null,
            to_o: null,

            // Label Chart
            label: new Date().getFullYear(),
            labelRevenu: 'vex Fees',
            labelExp: 'Transport fees',
            currency: '',
            idWharhouse: null,
            sellers: [],
            couriers: [],
            citiesPrices: [],
        };
    },
    computed: {
        warhouseSelected() {
            return this.$store.getters['wharhouse/warhouseSelected'];
        }
    },
    watch: {
        warhouseSelected: async function(oldVal, newVal) {
            this.$store.dispatch('actionloadingpage', { loading: true });
            await this.getwharhouseId();
            await this.getCurrency();
            await this.getSellers();
            await this.getProducts();
            this.$store.dispatch('actionloadingpage', { loading: false });
            this.countOrders = 0;
            this.sumrevenuorder = this.sumrevenus = 0;
            this.sumrevenusPending = 0;
            this.dataRevenusellerProducts = [];
            this.dataRevenusellerVilles = []
            this.labelsrevenusellerProducts = [];
            this.labelsrevenusellerVilles = [];
            await this.getTotalDelivery({
                DateType: this.timeserchd,
                Seller: this.timeserchsellerdelivery,
                Courier: this.timeserchcourierdelivery,
                country: await this.warhouseSelected,
            });
            await this.getRevenus_and_TopProducts_Stock({
                DateType: this.timeserch,
                Seller: this.timeserchseller,
                action: 'revenu',
                country: await this.warhouseSelected,
            });
            await this.getRevenus_and_TopProducts_Stock({
                DateType: this.timeserch,
                Sellerproduct: this.timeserchseller,
                country: await this.warhouseSelected,
                action: 'topproducts',
            });
            await this.getRevenus_and_TopProducts_Stock({
                DateType: this.timeserch,
                Sellerproduct: null,
                country: await this.warhouseSelected,
                action: 'topvilles',
            });
            await this.getConfirmationStatus({
                DateType: this.timeserchc,
                Seller: this.timeserchsellerconfirmation,
                country: await this.warhouseSelected,
            });
            await this.getOrders({
                DateType: this.timesercho,
                Seller: this.timeserchsellerorders,
            });
            if (this.currentUser.type == 'Admin' || this.currentUser.type == 'CEO') {
                await this.getAllSeller({
                    DateType: this.timeserchs,
                });
            }
        },
    },
    beforeMount() {
        const { authenticatedUser } = this.$store.state;

        if (authenticatedUser && this.$route.path === '/') {
            if (authenticatedUser.type === 'TeleConsultant') {
            this.$router.replace('/orders/confirmation');
            } else if (authenticatedUser.type === 'CallcenterManager') {
            this.$router.replace('callcenter');
            }
        }
    },
    async mounted() {
        this.$store.dispatch('actionloadingpage', { loading: true });
        this.token = this.$jwtService.verifyToken();
        await this.getwharhouseId();
        await this.getCurrency();
        await this.getUser();
        await this.getSellers();
        await this.getProducts();
        this.$store.dispatch('actionloadingpage', { loading: false });
        await this.getTotalDelivery({
            DateType: this.timeserchd,
            Seller: this.timeserchsellerdelivery,
            Courier: this.timeserchcourierdelivery,
            country: await this.warhouseSelected,
        });
        await this.getRevenus_and_TopProducts_Stock({
            DateType: this.timeserch,
            Seller: this.timeserchseller,
            action: 'revenu',
            country: await this.warhouseSelected,
        });
        await this.getRevenus_and_TopProducts_Stock({
            DateType: this.timeserchExp,
            Seller: this.timeserchsellerExp,
            action: 'expeditions',
        });
        await this.getRevenus_and_TopProducts_Stock({
            DateType: this.timeserch,
            Sellerproduct: this.timeserchseller,
            country: await this.warhouseSelected,
            action: 'topproducts',
        });
        await this.getRevenus_and_TopProducts_Stock({
            DateType: this.timeserch,
            Sellerproduct: null,
            country: await this.warhouseSelected,
            action: 'topvilles',
        });
        await this.getConfirmationStatus({
            DateType: this.timeserchc,
            Seller: this.timeserchsellerconfirmation,
            country: await this.warhouseSelected,
        });
        if (this.currentUser.type == 'Admin' || this.currentUser.type == 'CEO') {
            await this.getAllSeller({
                DateType: this.timeserchs,
            });
        }
        await this.getOrders({
            DateType: this.timesercho,
            Seller: this.timeserchsellerorders,
        });

        if (this.currentUser.type == 'Seller') {
            const res = await this.$server.search('products', {
                seller: this.currentUser._id,
                limit: 4000,
            });
            if (res.content.results) {
                this.products = res.content.results;
            } else this.products = [];
        }
    },
    methods: {
        async getwharhouseId() {
            await this.$store.dispatch('wharhouse/getwharhouseId').then(res => {
                this.idWharhouse = res;
            });
        },
        async getCitiesPrices() {
            const resCities2 = await this.$server.get('zones', {
                allCitiesAndFees: true,
                country: await this.warhouseSelected,
            });
            if (resCities2.content.length > 0) {
                for (let i in resCities2.content) {
                    for (let j in resCities2.content[i]._id.cities) {
                        this.citiesPrices.push({
                            name: resCities2.content[i]._id.cities[j],
                            price: resCities2.content[i]._id.price,
                        });
                    }
                }
            } else this.citiesPrices = [];
        },
        async getCurrency() {
            await this.$store.dispatch('wharhouse/getCurrency').then(res => {
                this.currency = res;
            });
        },
        async getSellers() {
            if (
                this.currentUser &&
                this.currentUser.type &&
                this.currentUser.type != 'Seller'
            ) {
                const res = await this.$server.search('users', {
                    type: 'Seller',
                    countries: await this.warhouseSelected,
                    limit: 4000,
                });
                if (res && res.content.results) this.sellers = res.content.results;
                else this.sellers = [];
                const resc = await this.$server.search('users', {
                    type: 'Courier',
                    countries: await this.warhouseSelected,
                    limit: 4000,
                });
                if (resc.content.results) this.couriers = resc.content.results;
                else this.couriers = [];
            }
        },
        async FindRecordRevenus(from, to) {
            this.labelsrevenu = [];
            this.dataRevenu = [];
            this.dataRevenuOrders = [];
            this.dataRevenuOrdersPending = [];
            this.countOrders = 0;
            this.sumrevenuorder = this.sumrevenus = 0;
            this.sumrevenusPending = 0;
            this.from_r = from;
            this.to_r = to;

            await this.getRevenus_and_TopProducts_Stock({
                DateType: 'betweendate',
                dates: { from: from, to: to },
                action: 'revenu',
                country: await this.warhouseSelected,
            });
        },
        async FindRecordShippings(from, to) {
            this.from_sh = from;
            this.to_sh = to;

            await this.getTotalDelivery({
                DateType: 'betweendate',
                dates: { from: from, to: to },
                totalPrice: this.timeserchpricedelivery,
                Courier: this.timeserchcourierdelivery ?
                    this.timeserchcourierdelivery._id || this.timeserchcourierdelivery :
                    null,
                Seller: this.timeserchsellerdelivery ?
                    this.timeserchsellerdelivery._id || this.timeserchsellerdelivery :
                    null,
                country: await this.warhouseSelected,
                product: this.timeserchproductdelivery ?
                    this.timeserchproductdelivery._id || this.timeserchproductdelivery :
                    null,
            });
        },
        async FindRecordOrders(from, to) {
            this.from_o = from;
            this.to_o = to;
            this.labelordersString = 'Days';
            await this.getOrders({
                DateType: 'betweendate',
                dates: { from: from, to: to },
                Seller: this.timeserchsellerorders,
            });
        },
        async FindRecordSellers(from, to) {
            this.from_s = from;
            this.to_s = to;

            await this.getAllSeller({
                DateType: 'betweendate',
                dates: { from: from, to: to },
            });
        },
        async FindRecordconfirmations(from, to) {
            this.from_c = from;
            this.to_c = to;

            await this.getConfirmationStatus({
                DateType: 'betweendate',
                dates: { from: from, to: to },
                country: await this.warhouseSelected,
            });
        },
        async getProductById(id) {
            const result = await this.$server.get('products', { _id: id });
            // 
            if (result.content) {
                var nom_product = result.content.name;
                if (nom_product && nom_product.length > 60)
                    nom_product = nom_product.substring(0, 60) + ' ...';
                return nom_product;
            }
        },
        GetMonthName(monthNumber) {
            var months = [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ];
            return months[monthNumber - 1];
        },
        getTymeType() {
            var type = '';
            if (this.timeserch == 'today') {
                type = 'hour';
            } else if (this.timeserch == 'thisyear') {
                type = 'month';
            } else {
                type = 'day';
            }
            return type;
        },
        getTymeTypeStock() {
            var type = '';
            if (this.timeserchStock == 'today') {
                type = 'hour';
            } else if (this.timeserchStock == 'thisyear') {
                type = 'month';
            } else {
                type = 'day';
            }
            return type;
        },
        getTymeTypeExp() {
            var type = '';
            if (this.timeserchExp == 'today') {
                type = 'hour';
            } else if (this.timeserchExp == 'thisyear') {
                type = 'month';
            } else {
                type = 'day';
            }
            return type;
        },
        async ChangeTypeDateRevenu(event) {
            if (event.target.name == 'revenu') {
                this.timeserch = event.target.value;

                if (event.target.value != 'betweendate') {
                    this.labelsrevenu = [];
                    this.dataRevenu = [];
                    this.dataRevenuOrders = [];
                    this.dataRevenuOrdersPending = [];
                    this.countOrders = 0;
                    this.sumrevenuorder = this.sumrevenus = 0;
                    this.sumrevenusPending = 0;
                    if (event.target.value == 'today') {
                        this.labelrevenuString = 'Hours';
                    } else if (event.target.value == 'thisyear') {
                        this.labelrevenuString = 'Months';
                    } else {
                        this.labelrevenuString = 'Days';
                    }
                } else {
                    this.labelrevenuString = 'Days';
                }
            } else if (event.target.name == 'stockhistories') {
                this.timeserchStock = event.target.value;
                this.labelsStock = [];
                this.dataStock = [];
                if (event.target.value == 'today') {
                    this.labelStringStock = 'Hours';
                } else if (event.target.value == 'thisyear') {
                    this.labelStringStock = 'Months';
                } else {
                    this.labelStringStock = 'Days';
                }
            } else if (event.target.name == 'expeditions') {
                this.timeserchExp = event.target.value;
                this.labelsExp = [];
                this.dataExp = [];
                this.dataExpFees = [];
                if (event.target.value == 'today') {
                    this.labelStringExp = 'Hours';
                } else if (event.target.value == 'thisyear') {
                    this.labelStringExp = 'Months';
                } else {
                    this.labelStringExp = 'Days';
                }
            } else {
                if (event.target.name === 'topproducts') {
                    this.timeserchtopproducts = event.target.value;
                    this.dataRevenusellerProducts = [];
                    this.labelsrevenusellerProducts = [];
                } else {
                    this.timeserchtopvilles = event.target.value;
                    this.dataRevenusellerVilles = [];
                    this.labelsrevenusellerVilles = [];
                }

            }

            if (event.target.value != 'betweendate') {
                await this.getRevenus_and_TopProducts_Stock({
                    DateType: event.target.value,
                    Product: this.timeserchtockhistoriesproducts,
                    action: event.target.name,
                    country: await this.warhouseSelected,
                });
            }
        },
        async ChangeSeller(seller, type) {
            this.timeserchseller = seller;
            this.dataRevenu = [];
            this.dataRevenuOrders = [];
            this.dataRevenuOrdersPending = [];
            this.sumrevenuorder = this.sumrevenus = 0;
            this.sumrevenusPending = 0;
            this.countOrders = 0;
            this.labelsrevenu = [];
            await this.getRevenus_and_TopProducts_Stock({
                DateType: this.timeserch,
                Seller: this.timeserchseller,
                action: 'revenu',
                country: await this.warhouseSelected,
            });
        },
        async ChangeSellerExp(seller) {
            this.timeserchsellerExp = seller._id;
            this.dataExp = [];
            this.dataExpFees = [];
            this.labelsExp = [];
            await this.getRevenus_and_TopProducts_Stock({
                DateType: this.timeserchExp,
                Seller: this.timeserchsellerExp,
                action: 'expeditions',
            });
        },
        async getProducts() {
            this.products = [];
            let filters = { 
                'details.warehouse': this.idWharhouse._id,
                limit: 4000
            };
            const res = await this.$server.search('products', filters);
            if (res.content.results) {
                this.products = res.content.results;
            } else this.products = [];
        },
        async ChangeProduct(product) {
            this.timeserchtockhistoriesproducts = product._id;
            this.dataStock = [];
            this.labelsStock = [];
            await this.getRevenus_and_TopProducts_Stock({
                DateType: this.timeserchStock,
                Product: this.timeserchtockhistoriesproducts,
                action: 'stockhistories',
            });
        },
        async ChangeSellerOrderProduct(seller) {
            this.timeserchsellerproduct = seller._id;
            this.dataRevenusellerProducts = [];
            this.labelsrevenusellerProducts = [];
            await this.getRevenus_and_TopProducts_Stock({
                DateType: this.timeserchtopproducts,
                Sellerproduct: this.timeserchsellerproduct,
                country: await this.warhouseSelected,
                action: 'topproducts',
            });
        },
        async ChangeSellerOrderVilles(seller, type) {
            console.log('seller ChangeSellerOrderVilles-----', seller)
            console.log('type ChangeSellerOrderVilles-----', type)
            if (type === 'seller') this.timeserchsellerville = seller ? seller._id || seller : null;
            else this.timeserchcouriertopvilles = seller ? seller._id || seller : null;
            this.dataRevenusellerVilles = [];
            this.labelsrevenusellerVilles = [];
            console.log('filter getRevenus_and_TopProducts_Stock-----', {
                DateType: this.timeserchtopvilles,
                Sellerproduct: this.timeserchsellerville || null,
                Courier: this.timeserchcouriertopvilles || null,
                country: await this.warhouseSelected,
                action: 'topvilles',
            })
            await this.getRevenus_and_TopProducts_Stock({
                DateType: this.timeserchtopvilles,
                Sellerproduct: this.timeserchsellerville || null,
                Courier: this.timeserchcouriertopvilles || null,
                country: await this.warhouseSelected,
                action: 'topvilles',
            });
        },
        async getUser() {
            const res = await this.$server.me('users');

            if (res.content) this.currentUser = res.content;
            else this.currentUser = {};
        },
        // async getOrders(filters) {
        //   const res = await this.$server.getOrders("analytics", filters);
        //   this.tab = res.content;
        // },
        async getRevenus_and_TopProducts_Stock(filters) {
            console.log('filters.action--------', filters.action)
            if (filters.action == 'revenu') {
                filters.Seller = this.timeserchseller;
            } else if (filters.action == 'stockhistories') filters.SellerproductStock = this.timeserchstockhistoriesSeller;
            else if (filters.action == 'topproducts') filters.Sellerproduct = this.timeserchsellerproduct;
            else filters.Sellerproduct = this.timeserchsellerville;

            filters.warhouse = this.idWharhouse._id;

            const res = await this.$server.getRevenus_and_TopProducts_Stock(
                'analytics',
                filters,
            );
            console.log('res getRevenus_and_TopProducts_Stock--------', res)
            var nom_product = '';
            if (res && res.content) {
                if (filters.action == 'revenu') {
                    // res.content.sort(
                    //   (a, b) => a._id[this.getTymeType()] - b._id[this.getTymeType()]
                    // );
                } else if (filters.action == 'expeditions')
                    res.content.sort(
                        (a, b) =>
                        a._id[this.getTymeTypeExp()] - b._id[this.getTymeTypeExp()],
                    );
                else {
                    res.content.sort(
                        (a, b) =>
                        a._id[this.getTymeTypeStock()] - b._id[this.getTymeTypeStock()],
                    );
                }

                if (filters.action == 'revenu') {

                    this.dataRevenu = res.content.total_revenus;
                    this.dataRevenuOrders = res.content.total_revenus_orders;
                    this.dataRevenuOrdersPending = res.content.dataPendingToPaid;
                    this.countOrders = res.content.countOrders;
                    if (this.timeserch == 'today') {
                        this.labelsrevenu = this.labels;
                    } else if (this.timeserch == 'thisyear') {
                        this.labelsrevenu = this.labelsMonths;
                    } else if (
                        this.timeserch == 'thisweek' ||
                        this.timeserch == 'lastweek'
                    ) {
                        this.labelsrevenu = res.content.label;
                    } else if (this.timeserch == 'betweendate') {
                        this.labelsrevenu = res.content.label;
                        if (res.content.countMonths > 1) {
                            for (let i in this.labelsrevenu) {
                                this.labelsrevenu[i] = this.GetMonthName(this.labelsrevenu[i]);
                            }
                        }
                    } else {
                        let nbrjours = this.getNumberOfMonths();
                        for (let i = 1; i <= nbrjours; i++) {
                            this.labelsrevenu.push(i);
                        }
                    }

                    for (let j in this.dataRevenuOrders) {
                        this.sumrevenuorder += this.dataRevenuOrders[j];
                    }
                    for (let l in this.dataRevenuOrdersPending) {
                        this.sumrevenusPending += this.dataRevenuOrdersPending[l];
                    }
                    for (let j in this.dataRevenu) {
                        this.sumrevenus += this.dataRevenu[j];
                    }
                }
                if (filters.action != 'revenu') {

                    for (const element of res.content) {
                        if (filters.action == 'stockhistories') {
                            this.dataStock.push(element.quantityInStock);
                            if (this.timeserchStock == 'today') {
                                this.labelsStock.push(('0' + element._id.hour).slice(-2));
                            } else if (this.timeserchStock == 'thisyear') {
                                this.labelsStock.push(this.GetMonthName(element._id.month));
                            } else {
                                this.labelsStock.push(('0' + element._id.day).slice(-2));
                            }
                        }
                        if (filters.action == 'expeditions') {
                            this.dataExpFees.push(element.transport_fees);
                            this.dataExp.push(element.count);
                            if (this.timeserch == 'today') {
                                this.labelsExp.push(('0' + element._id.hour).slice(-2));
                            } else if (this.timeserch == 'thisyear') {
                                this.labelsExp.push(this.GetMonthName(element._id.month));
                            } else {
                                this.labelsExp.push(('0' + element._id.day).slice(-2));
                            }
                        }
                        if (filters.action == 'topproducts') {
                            //top product
                            this.dataRevenusellerProducts.push(element.totalSales);
                            nom_product = await this.getProductById(element._id.productId);
                            this.labelsrevenusellerProducts.push(nom_product);
                        }
                        if (filters.action == 'topvilles') {
                            //top villes
                            console.log('element topvilles-----', element)
                            this.dataRevenusellerVilles.push(element.totalSales);
                            this.labelsrevenusellerVilles.push(element._id.city);
                        }
                    }
                }
            } else {
                if (filters.action == 'revenu') {
                    this.dataRevenu = [];
                    this.dataRevenuOrders = [];
                    this.dataRevenuOrdersPending = [];
                    this.sumrevenuorder = this.sumrevenus = 0;
                    this.sumrevenusPending = 0;
                    this.countOrders = 0;
                    this.labelsrevenu = [];
                }
                if (filters.action == 'expeditions') {
                    this.dataExp = [];
                    this.dataExpFees = [];
                    this.labelsExp = [];
                }
            }
        },
        async getNumberOfOrders(filters) {
            const res = await this.$server.getNumberOfOrders('analytics', filters);
            this.tabordersbystatus = res.content;
        },
        getNumberOfMonths() {
            let today = new Date();
            let month = today.getMonth() + 1;
            let year = today.getFullYear();

            let nbr_jours = new Date(year, month, 0).getDate();
            this.labels = [];
            return nbr_jours;
        },
        getNumberOfDaysLastMonths() {
            let today = new Date();
            let month = today.getMonth() + 1;
            let year = today.getFullYear();
            let nbr_jours;
            if (month == 1) {
                nbr_jours = new Date(year - 1, 12, 0).getDate();
            } else {
                nbr_jours = new Date(year, month - 1, 0).getDate();
            }
            this.labels = [];
            return nbr_jours;
        },
        async getOrdersBetweenTwoDate() {
            const data = {
                startDate: this.formData.startDate,
                endDate: this.formData.endDate,
            };
            if (
                this.formData.startDate != undefined &&
                this.formData.endDate != undefined
            ) {
                const res = await this.$server.getOrdersBetweenTwoDate(
                    'analytics',
                    data,
                );
                this.duree = '';
                this.duree = 'Two Date';
                return res.content;
            }
        },
        // Delivery
        async ChangeTypeDateDelivery(event) {
            this.timeserchd = event.target.value;

            if (event.target.value != 'betweendate') {
                this.labelsdelivery = [];
                this.dataDelivery = [];
                if (event.target.value == 'today') {
                    this.labeldeliveryString = 'Hours';
                } else if (event.target.value == 'thisyear') {
                    this.labeldeliveryString = 'Months';
                } else {
                    this.labeldeliveryString = 'Days';
                }
                await this.getTotalDelivery({
                    DateType: this.timeserchd,
                    totalPrice: this.timeserchpricedelivery,
                    Courier: this.timeserchcourierdelivery ?
                        this.timeserchcourierdelivery._id || this.timeserchcourierdelivery :
                        null,
                    Seller: this.timeserchsellerdelivery ?
                        this.timeserchsellerdelivery._id || this.timeserchsellerdelivery :
                        null,
                    country: await this.warhouseSelected,
                    product: this.timeserchproductdelivery ?
                        this.timeserchproductdelivery._id || this.timeserchproductdelivery :
                        null,
                });
            } else {
                this.labeldeliveryString = 'Days';
            }
        },
        async getTotalDelivery(filters) {
            filters.ThirdParty = this.timeserchsaffiliate_storesdelivery || null;
            const res = await this.$server.getTotalDelivery('analytics', filters);

            if (res && res.content) {
                this.dataDelivery = res.content.status;
                this.totalShippings = res.content.countAll;
            } else {
                this.dataDelivery = [];
                this.totalShippings = [];
            }
        },
        async ChangeSellerDelivery(seller, action) {
            if (seller) {
                this.datadelivery = [];
                if (action && (action == 'Seller' || action == 'Courier')) {
                    if (action == 'Seller') {
                        this.timeserchsellerdelivery = seller;
                        this.timeserchproductdelivery = null;
                        this.timeserchpricedelivery = null;
                    } else this.timeserchcourierdelivery = seller;

                    await this.getTotalDelivery({
                        DateType: this.timeserchd,
                        totalPrice: this.timeserchpricedelivery,
                        Courier: this.timeserchcourierdelivery ?
                            this.timeserchcourierdelivery._id ||
                            this.timeserchcourierdelivery :
                            null,
                        Seller: this.timeserchsellerdelivery ?
                            this.timeserchsellerdelivery._id || this.timeserchsellerdelivery :
                            null,
                        country: await this.warhouseSelected,
                    });
                    if (action == 'Seller') {
                        this.products = [];
                        const res = await this.$server.search('products', {
                            seller: seller._id || seller,
                            'details.warehouse': this.idWharhouse._id,
                            limit: 4000
                        });
                        if (res.content.results) {
                            this.products = res.content.results;
                        } else this.products = [];
                    }

                    await this.getStoresAffiliate();
                }
                if (action && action == 'product') {
                    this.timeserchproductdelivery = seller;
                    this.timeserchpricedelivery = null;
                    await this.getTotalDelivery({
                        DateType: this.timeserchd,
                        totalPrice: this.timeserchpricedelivery,
                        Courier: this.timeserchcourierdelivery ?
                            this.timeserchcourierdelivery._id ||
                            this.timeserchcourierdelivery :
                            null,
                        Seller: this.timeserchsellerdelivery._id || this.timeserchsellerdelivery,
                        country: await this.warhouseSelected,
                        product: this.timeserchproductdelivery ?
                            this.timeserchproductdelivery._id ||
                            this.timeserchproductdelivery :
                            null,
                    });
                    let filters = {
                        country: this.idWharhouse.country,
                        product: this.timeserchproductdelivery._id ||
                            this.timeserchproductdelivery,
                        seller: this.timeserchsellerdelivery._id || this.timeserchsellerdelivery,
                        table: 'shippings',
                    };
                    await this.$store
                        .dispatch('wharhouse/searchPricesOrders', filters)
                        .then(res => {
                            this.prices = res;
                        });
                    await this.getStoresAffiliate();
                }
                if (action && action == 'prices') {
                    this.timeserchpricedelivery = seller;
                    await this.getTotalDelivery({
                        DateType: this.timeserchd,
                        totalPrice: this.timeserchpricedelivery,
                        Courier: this.timeserchcourierdelivery ?
                            this.timeserchcourierdelivery._id ||
                            this.timeserchcourierdelivery :
                            null,
                        Seller: this.timeserchsellerdelivery ?
                            this.timeserchsellerdelivery._id || this.timeserchsellerdelivery :
                            null,
                        country: await this.warhouseSelected,
                        product: this.timeserchproductdelivery ?
                            this.timeserchproductdelivery._id ||
                            this.timeserchproductdelivery :
                            null,
                    });
                }
                if (action && action == 'stores') {
                    console.log('stores-----', seller)
                    this.timeserchsaffiliate_storesdelivery = seller;
                    await this.getTotalDelivery({
                        DateType: this.timeserchd,
                        totalPrice: this.timeserchpricedelivery,
                        Courier: this.timeserchcourierdelivery ?
                            this.timeserchcourierdelivery._id ||
                            this.timeserchcourierdelivery :
                            null,
                        Seller: this.timeserchsellerdelivery ?
                            this.timeserchsellerdelivery._id || this.timeserchsellerdelivery :
                            null,
                        country: await this.warhouseSelected,
                        ThirdParty: this.timeserchsaffiliate_storesdelivery,
                        product: this.timeserchproductdelivery ?
                            this.timeserchproductdelivery._id ||
                            this.timeserchproductdelivery :
                            null,
                    });
                }
            } else {
                if (action && (action == 'Seller' || action == 'Courier')) {
                    if (action == 'Seller') {
                        this.timeserchsellerdelivery = null;
                        this.timeserchproductdelivery = null;
                        this.timeserchpricedelivery = null;
                    } else this.timeserchcourierdelivery = null;
                    await this.getTotalDelivery({
                        DateType: this.timeserchd,
                        totalPrice: this.timeserchpricedelivery,
                        country: await this.warhouseSelected,
                        Courier: this.timeserchcourierdelivery ?
                            this.timeserchcourierdelivery._id ||
                            this.timeserchcourierdelivery :
                            null,
                        Seller: this.timeserchsellerdelivery ?
                            this.timeserchsellerdelivery._id || this.timeserchsellerdelivery :
                            null,
                    });
                    if (action == 'Seller') {
                        this.products = [];
                        const res = await this.$server.search('products', {
                            'details.warehouse': this.idWharhouse._id,
                            limit: 4000
                        });
                        if (res.content.results) {
                            this.products = res.content.results;
                        } else this.products = [];
                    }
                }
                if (action && action == 'product') {
                    this.timeserchproductdelivery = null;
                    this.timeserchpricedelivery = null;
                    this.prices = [];
                    await this.getTotalDelivery({
                        DateType: this.timeserchd,
                        totalPrice: this.timeserchpricedelivery,
                        Courier: this.timeserchcourierdelivery ?
                            this.timeserchcourierdelivery._id ||
                            this.timeserchcourierdelivery :
                            null,
                        Seller: this.timeserchsellerdelivery._id || this.timeserchsellerdelivery,
                        country: await this.warhouseSelected,
                        product: this.timeserchproductdelivery ?
                            this.timeserchproductdelivery._id ||
                            this.timeserchproductdelivery :
                            null,
                    });
                }
                if (action && action == 'prices') {
                    this.timeserchpricedelivery = null;
                    await this.getTotalDelivery({
                        DateType: this.timeserchd,
                        totalPrice: this.timeserchpricedelivery,
                        Courier: this.timeserchcourierdelivery ?
                            this.timeserchcourierdelivery._id ||
                            this.timeserchcourierdelivery :
                            null,
                        Seller: this.timeserchsellerdelivery ?
                            this.timeserchsellerdelivery._id || this.timeserchsellerdelivery :
                            null,
                        country: await this.warhouseSelected,
                        product: this.timeserchproductdelivery ?
                            this.timeserchproductdelivery._id ||
                            this.timeserchproductdelivery :
                            null,
                    });
                }
                if (action && action == 'stores') {
                    this.timeserchsaffiliate_storesdelivery = null;
                    await this.getTotalDelivery({
                        DateType: this.timeserchd,
                        totalPrice: this.timeserchpricedelivery,
                        Courier: this.timeserchcourierdelivery ?
                            this.timeserchcourierdelivery._id ||
                            this.timeserchcourierdelivery :
                            null,
                        Seller: this.timeserchsellerdelivery ?
                            this.timeserchsellerdelivery._id || this.timeserchsellerdelivery :
                            null,
                        country: await this.warhouseSelected,
                        ThirdParty: null,
                        product: this.timeserchproductdelivery ?
                            this.timeserchproductdelivery._id ||
                            this.timeserchproductdelivery :
                            null,
                    });
                }
            }
        },
        async getStoresAffiliate(event) {
            this.stores = [];
            if (this.timeserchsellerdelivery && this.timeserchsellerdelivery._id.toString() === '64d60cfc05f818068c8f4750' && this.currentUser.type !== 'Seller') {

                let filtersearchStoresOrders = { seller: this.timeserchsellerdelivery._id, country: await this.warhouseSelected, table: 'shippings' };
                if (this.timeserchproductdelivery) filtersearchStoresOrders.product = this.timeserchproductdelivery._id || this.timeserchproductdelivery;
                if (this.timeserchcourierdelivery) filtersearchStoresOrders.courier = this.timeserchcourierdelivery._id || this.timeserchcourierdelivery;

                await this.$store.dispatch('wharhouse/searchStoresOrders', filtersearchStoresOrders).then(res => {
                    console.log('res searchStoresOrders--------', res)
                    this.stores = res;
                });
            }
        },
        // Fin Delivery

        // Debut Confirmation Status
        async ChangeTypeDateConfirmation(event) {
            this.timeserchc = event.target.value;
            if (event.target.value != 'betweendate') {
                this.dataconfirmation = [];
                if (event.target.value == 'today') {
                    this.labelconfirmationString = 'Hours';
                } else if (event.target.value == 'thisyear') {
                    this.labelconfirmationString = 'Months';
                } else {
                    this.labelconfirmationString = 'Days';
                }

                await this.getConfirmationStatus({
                    DateType: event.target.value,
                    country: await this.warhouseSelected,
                });
            }
        },
        async getConfirmationStatus(filters) {
            filters.Seller = this.timeserchsellerconfirmation;
            const res = await this.$server.getConfirmationStatus(
                'analytics',
                filters,
            );

            if (res.content) {
                this.dataconfirmation = res.content.status;
                this.countConfirmations = res.content.countAll;
            }
        },
        async ChangeSellerConfirmation(seller) {
            this.timeserchsellerconfirmation = seller._id;

            this.dataconfirmation = [];

            await this.getConfirmationStatus({
                DateType: this.timeserchc,
                Seller: this.timeserchsellerconfirmation,
                country: await this.warhouseSelected,
            });
        },
        // Fin Confirmation Status

        // Total Seller
        async ChangeTypeDateAllSeller(event) {
            this.timeserchs = event.target.value;
            if (event.target.value != 'betweendate') {
                this.dataAllSeller = [];
                if (event.target.value == 'today') {
                    this.labelAllsellerString = 'Hours';
                } else if (event.target.value == 'thisyear') {
                    this.labelAllsellerString = 'Months';
                } else {
                    this.labelAllsellerString = 'Days';
                }

                await this.getAllSeller({
                    DateType: event.target.value,
                });
            }
        },
        async getAllSeller(filters) {
            filters['country'] = await this.warhouseSelected;
            const res = await this.$server.getAllSeller('analytics', filters);
            if (res.content) {
                this.countSellers = 0;
                this.dataAllSeller = res.content.status;
                for (let i in this.dataAllSeller) {
                    this.countSellers += this.dataAllSeller[i];
                }
            }
        },
        // Fin total Seller

        // Total Orders
        async ChangeTypeDateOrders(event) {
            this.timesercho = event.target.value;
            if (event.target.value != 'betweendate') {
                this.dataorders = [];
                this.labels = [];
                if (event.target.value == 'today') {
                    this.labelordersString = 'Hours';
                    if (this.timesercho == 'today') {
                        this.labels = [
                            '00:00',
                            '01:00',
                            '02:00',
                            '03:00',
                            '04:00',
                            '05:00',
                            '06:00',
                            '07:00',
                            '08:00',
                            '09:00',
                            '10:00',
                            '11:00',
                            '12:00',
                            '13:00',
                            '14:00',
                            '15:00',
                            '16:00',
                            '17:00',
                            '18:00',
                            '19:00',
                            '20:00',
                            '21:00',
                            '22:00',
                            '23:00',
                        ];
                    }
                } else if (event.target.value == 'thismonth') {
                    this.labelordersString = 'Days';
                    if (this.timesercho == 'thismonth') {
                        let nbrjours = this.getNumberOfMonths();
                        for (let i = 1; i <= nbrjours; i++) {
                            this.labels.push(i);
                        }
                    }
                } else {
                    this.labelordersString = 'Months';
                    this.labels = [
                        'January',
                        'February',
                        'March',
                        'April',
                        'May',
                        'June',
                        'July',
                        'August',
                        'September',
                        'October',
                        'November',
                        'December',
                    ];
                }

                await this.getOrders({
                    DateType: event.target.value,
                    Seller: this.timeserchsellerorders,
                });
            }
        },
        async getOrders(filters) {
            filters.Seller = this.timeserchsellerorders;
            filters.country = await this.warhouseSelected;
            filters.timezone = this.$momentTimezone.tz.guess();
            const res = await this.$server.getOrders('analytics', filters);

            if (res.content) {
                if (filters.DateType == 'betweendate') {
                    this.dataorders = res.content.total_orders;
                    this.labels = res.content.label;
                    if (res.content.countMonths > 1) {
                        for (let i in this.labels) {
                            this.labels[i] = this.GetMonthName(this.labels[i]);
                        }
                    } else this.labels = res.content.label;
                } else this.dataorders = res.content;
            }
        },
        async ChangeSellerOrders(seller) {
            this.timeserchsellerorders = seller._id;
            this.dataorders = [];

            await this.getOrders({
                DateType: this.timesercho,
                Seller: this.timeserchsellerorders,
            });
        },
        // Fin total Orders
    },
};
</script>

<style scoped>
.vs__dropdown-toggle {
    border: none;
}

.icon::after {
    content: '';
    display: block;
    position: absolute;
    border-top: 23px solid transparent;
    border-bottom: 17px solid transparent;
    border-left: 12px solid #3182ce;
    left: 100%;
    top: 0;
}

.h-350-px {
    height: 350px;
}

.bg-transparent {
    background-color: transparent !important;
}

.card-header {
    padding: 1.25rem 1.5rem;
    margin-bottom: 0;
    background-color: #fff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.align-items-center {
    -webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
}

.row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
}

.text-light {
    color: #ced4da !important;
}

.ls-1 {
    letter-spacing: 0.0625rem;
}

.justify-content-end {
    -webkit-box-pack: end !important;
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
}

.nav {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
}

.nav-pills .nav-item:not(:last-child) {
    padding-right: 1rem;
}

.nav-pills .nav-link {
    padding: 0.75rem 1rem;
    color: #5e72e4;
    font-weight: 500;
    font-size: 0.875rem;
    -webkit-box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    background-color: #fff;
    -webkit-transition: all 0.15s ease;
    transition: all 0.15s ease;
}

.nav-pills .nav-link {
    border-radius: 0.375rem;
}

.d-md-block {
    display: block !important;
}

.card-body {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    min-height: 1px;
    padding: 1.5rem;
}

.col {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    max-width: 100%;
    position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
}
</style>
